// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"e0b885ae","placeholder":"a52bbd8a","shimmer":"f5b5f8ae"};